// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Kstt1LFLUuSL6WAY8Acb {
  margin: 10px 0 10px 0;
}

.mYmnHNMAOvgT8Np52Inf {
  padding-bottom: 10px;
}
.mFLWpvzovDUc9stg4nwa {
  position: relative;
  margin-bottom: 25px;
  background-color: white;
  min-height: 58px;
  box-shadow: rgba(63, 63, 68, 0.02) 0px 0px 0px 1px, rgba(63, 63, 68, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 2px
}

.mqZkIedKnVP8M_QK7IiB {
  border-bottom: 1px solid #D6D6D6;
  margin: 10px -20px;
}

.HZEHX7x3qcsihVM3bPcV {
  border-bottom: 1px solid #D6D6D6;
  margin: 40px -20px;
}

.h0U3mYe0Vfnp1nqKneil {
  padding: 0 20px 0 20px;
  margin: 10px -20px;
}

.RlMeC79tg8onCpt8tSlN {
  display: none;
}

.PiG7gOWM_sEyuDEagNIg {
  width: 100%;
  height: 20px;
  margin: 20px 0;
}

.C7pkFaEEEncYYNafB4EL, .C7pkFaEEEncYYNafB4EL:hover, .C7pkFaEEEncYYNafB4EL:active, .C7pkFaEEEncYYNafB4EL:focus {
  background-color: #c5c5c5;
  border-color: #c5c5c5;
  color: white !important;
}

.xCEvp6zOIuycCJmeq5rE {
  margin-top: 20px;
}

.Z31pO4ZqfQaoQp1RRLuA {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 20px;
  height: 100px;
}

.NRQ4ysJ5EWMCR_l9Ni7_ {
  margin-bottom: 30px;
  margin-top: 30px;
}

.ND02cgxj_V8FC46GFsKd {
    border: 1px solid #d1d1d1;
    padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-activities/interestsActivities.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".buttonBar {\n  margin: 10px 0 10px 0;\n}\n\n.skipContainer {\n  padding-bottom: 10px;\n}\n.subheader {\n  position: relative;\n  margin-bottom: 25px;\n  background-color: white;\n  min-height: 58px;\n  box-shadow: rgba(63, 63, 68, 0.02) 0px 0px 0px 1px, rgba(63, 63, 68, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 2px\n}\n\n.dividerTop {\n  border-bottom: 1px solid #D6D6D6;\n  margin: 10px -20px;\n}\n\n.dividerBottom {\n  border-bottom: 1px solid #D6D6D6;\n  margin: 40px -20px;\n}\n\n.messageComponentWrapper {\n  padding: 0 20px 0 20px;\n  margin: 10px -20px;\n}\n\n.hidden {\n  display: none;\n}\n\n.addNoteDiv {\n  width: 100%;\n  height: 20px;\n  margin: 20px 0;\n}\n\n.buttonSecondaryColor, .buttonSecondaryColor:hover, .buttonSecondaryColor:active, .buttonSecondaryColor:focus {\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n  color: white !important;\n}\n\n.activityFeedCard {\n  margin-top: 20px;\n}\n\n.messageInfoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-top: 20px;\n  height: 100px;\n}\n\n.templateFormContainer {\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n\n.logCallSelect {\n    border: 1px solid #d1d1d1;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBar": `Kstt1LFLUuSL6WAY8Acb`,
	"skipContainer": `mYmnHNMAOvgT8Np52Inf`,
	"subheader": `mFLWpvzovDUc9stg4nwa`,
	"dividerTop": `mqZkIedKnVP8M_QK7IiB`,
	"dividerBottom": `HZEHX7x3qcsihVM3bPcV`,
	"messageComponentWrapper": `h0U3mYe0Vfnp1nqKneil`,
	"hidden": `RlMeC79tg8onCpt8tSlN`,
	"addNoteDiv": `PiG7gOWM_sEyuDEagNIg`,
	"buttonSecondaryColor": `C7pkFaEEEncYYNafB4EL`,
	"activityFeedCard": `xCEvp6zOIuycCJmeq5rE`,
	"messageInfoContainer": `Z31pO4ZqfQaoQp1RRLuA`,
	"templateFormContainer": `NRQ4ysJ5EWMCR_l9Ni7_`,
	"logCallSelect": `ND02cgxj_V8FC46GFsKd`
};
export default ___CSS_LOADER_EXPORT___;
